import React from "react";

/**
 * See Chelle brand logo using the real production asset.
 * Stored locally so the live site does not depend on Emergent-hosted files.
 */
const LOGO_URL = "/seechelle-logo.png";

const HEIGHTS = {
  sm: "h-9 md:h-10",
  md: "h-11 md:h-14",
  lg: "h-24 md:h-32 lg:h-36",
  xl: "h-28 md:h-40",
};

export const Logo = ({ size = "md", className = "" }) => {
  const h = HEIGHTS[size] || HEIGHTS.md;
  return (
    <img
      src={LOGO_URL}
      alt="See Chelle"
      className={`${h} w-auto select-none ${className}`}
      draggable="false"
      data-testid="see-chelle-logo"
    />
  );
};

export default Logo;
